export default __webpack_public_path__ + "static/media/VIRTUAL_PHONE.7576b17d.png";